import _ from "lodash";
import { ModifiableKeyMultiSelect } from "./ModifiableKeyMultiSelect";

export const ModifiableKeyMultiSelectEnumChoices = ({
  options,
  formatLabel,
  ...props
}: {
  label: string;
  loading?: boolean;
  appId?: string;
  path: string;
  options: string[];
  formatLabel?: ((val: string) => string) | Record<string, string>;
  mutateValueBeforeUpdate?: (val: string) => any;
  formatValue?: (val: string) => any;
  className?: string;
  tooltip?: string;
  defaultValues?: string[];
}) => {
  const formatLabelFn =
    typeof formatLabel === "function" ? formatLabel : (x: string) => formatLabel?.[x] ?? _.startCase(x);

  const optionsWithLabels = options.map((option) => ({
    value: option,
    label: formatLabelFn(option),
  }));

  return <ModifiableKeyMultiSelect {...props} formatLabel={formatLabelFn} options={optionsWithLabels} />;
};
